import {Platform} from "@variocube/app-api";
import {EventSupportingApp} from "@variocube/app-common";
import {AppContext, AppErrorBoundary, ThemeProvider, useDeactivateListener} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {CleanerView} from "./cleaner";
import {OrderFlow} from "./customer";
import icon from "./hanger.svg";
import {HomeView} from "./home";
import {loadMockData} from "./mock";
import {Cleaner, CubeOrder} from "./model";
import {render} from "react-dom";
import {LocalizationProvider, SUPPORTED_LANGUAGES} from "../i18n";

export default class extends EventSupportingApp {

    constructor(platform: Platform) {
        super(platform, icon, "#1c70b8", SUPPORTED_LANGUAGES);
    }

    render(appRoot: Element) {
        const appContext = {
            platform: this.platform,
            appEventSupport: this.eventSupport
        };
        render((
            <AppContext.Provider value={appContext}>
                <ThemeProvider defaultTheme={theme}>
                    <AppErrorBoundary appId={this.platform.appId} cubeId={this.platform.hostname}>
                        <LocalizationProvider app={this}>
                            <ClesyCleanShell/>
                        </LocalizationProvider>
                    </AppErrorBoundary>
                </ThemeProvider>
            </AppContext.Provider>
        ), appRoot);
    }

    loadMockData() {
        return loadMockData(this.platform);
    }
}

const theme = {
    colorPrimary: "#1c70b8",
    colorBackground: "#fff",
    colorForeground: "#444"
};

function ClesyCleanShell() {
    const [cleaner, setCleaner] = useState<Cleaner>();
    const [order, setOrder] = useState<CubeOrder>();

    const handleDeactivate = useCallback(async () => {
        if (cleaner || order) {
            throw new Error("Cannot deactivate now.");
        }
    }, [cleaner, order]);
    useDeactivateListener(handleDeactivate);

    const handleOrderDone = useCallback(() => setOrder(undefined), []);
    const handleCleanerDone = useCallback(() => setCleaner(undefined), []);

    if (order) {
        return <OrderFlow order={order} onDone={handleOrderDone}/>;
    } else if (cleaner) {
        return <CleanerView onDone={handleCleanerDone}/>;
    } else {
        return <HomeView onCleaner={setCleaner} onOrder={setOrder}/>;
    }
}
